import { useState } from 'react';
import { getApiErrorMessage, postEmail } from '../services/emailApi';

const useResetPassword = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null)

    const resetPassword = async ({ resetToken, newPassword }) => {

        setLoading(true)
        setError(null)
        setResponse(null)

        try {
            const res = await postEmail('/password-reset/reset', { resetToken, newPassword });
            setResponse(res.data.message)

        } catch (err) {
            setError(getApiErrorMessage(err, 'Não foi possível redefinir a senha. Tente novamente.'));
        } finally {
            setLoading(false);
        }
    };
    return { resetPassword, response, loading, error };
}

export default useResetPassword
